import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card.jsx";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs.jsx";
import ClientTicketStats from './ClientTicketStats';
import RecentTickets from './RecentTickets';
import TicketsByStatusChart from './TicketsByStatusChart';
import TicketTimeline from './TicketTimeline';

import QuickActions from './QuickActions';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../utils/index.ts';
import { Button } from '../ui/button.jsx';
import { PlusCircle } from 'lucide-react';

export default function ClientDashboard({ data, user, isLoading }) {
  const { tickets = [], stats = {} } = data || {};

  return (
    <>
      <QuickActions isAdmin={false} />
    
      <div className="flex justify-between items-center">
        <ClientTicketStats 
          stats={stats.tickets || {
            total: 0,
            open: 0,
            overdue: 0,
            resolved: 0
          }}
          isLoading={isLoading}
        />
        
        <Link to={createPageUrl('NewTicket')}>
          <Button className="bg-primary hover:bg-primary/90">
            <PlusCircle className="mr-2 h-4 w-4" />
            Abrir Novo Chamado
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Status dos Seus Chamados</CardTitle>
          </CardHeader>
          <CardContent>
            <TicketsByStatusChart 
              tickets={tickets}
              isLoading={isLoading}
            />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Histórico de Chamados</CardTitle>
          </CardHeader>
          <CardContent>
            <TicketTimeline 
              tickets={tickets}
              isLoading={isLoading}
            />
          </CardContent>
        </Card>
      </div>



      <Tabs defaultValue="all" className="mt-6">
        <TabsList>
          <TabsTrigger value="all">Todos Chamados</TabsTrigger>
          <TabsTrigger value="open">Em Aberto</TabsTrigger>
          <TabsTrigger value="resolved">Resolvidos</TabsTrigger>
        </TabsList>
        <TabsContent value="all">
          <RecentTickets 
            tickets={tickets}
            isLoading={isLoading}
            isInternalUser={false}
          />
        </TabsContent>
        <TabsContent value="open">
          <RecentTickets 
            tickets={tickets.filter(t => 
              ['open', 'analysis', 'in_progress', 'reopened'].includes(t.status)
            )}
            isLoading={isLoading}
            isInternalUser={false}
          />
        </TabsContent>
        <TabsContent value="resolved">
          <RecentTickets 
            tickets={tickets.filter(t => 
              ['resolved', 'closed'].includes(t.status)
            )}
            isLoading={isLoading}
            isInternalUser={false}
          />
        </TabsContent>
      </Tabs>
    </>
  );
}